export interface Movie {
  id: string;
  title: string;
  titleEn: string;
  year: number;
  rating: number;
  category: string;
  categorySlug: string;
  description: string;
  director: string;
  cast: string[];
  duration: string;
  region: string;
  posterUrl: string;
  isHot: boolean;
  isNew: boolean;
  views: number;
  tags: string[];
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '动作片', slug: 'action' },
  { name: '喜剧片', slug: 'comedy' },
  { name: '科幻片', slug: 'scifi' },
  { name: '爱情片', slug: 'romance' },
  { name: '恐怖片', slug: 'horror' },
  { name: '动画片', slug: 'animation' },
  { name: '纪录片', slug: 'documentary' },
  { name: '战争片', slug: 'war' },
  { name: '悬疑片', slug: 'mystery' },
];

export const movies: Movie[] = [
  {
    id: '1',
    title: '星际穿越',
    titleEn: 'Interstellar',
    year: 2014,
    rating: 9.4,
    category: '科幻片',
    categorySlug: 'scifi',
    description: '一组探险者穿越虫洞，为人类寻找新家园的壮丽旅程。在浩瀚宇宙中，时间与空间的界限被打破，父女之间的爱成为跨越维度的纽带。导演克里斯托弗·诺兰以惊人的视觉效果和深刻的情感内核，打造了一部关于人类命运与亲情的科幻史诗。',
    director: '克里斯托弗·诺兰',
    cast: ['马修·麦康纳', '安妮·海瑟薇', '杰西卡·查斯坦', '迈克尔·凯恩'],
    duration: '169分钟',
    region: '美国',
    posterUrl: 'https://readdy.ai/api/search-image?query=Interstellar%20movie%20poster%20style%2C%20astronaut%20floating%20in%20space%20near%20a%20wormhole%2C%20distant%20galaxy%2C%20cinematic%20lighting%2C%20dramatic%20shadows%2C%20film%20poster%20aesthetic%2C%20deep%20black%20space%20background%2C%20sci-fi%20atmosphere%2C%20minimalist%20design%2C%20warm%20golden%20accents&width=800&height=1200&seq=movie-interstellar-poster&orientation=portrait',
    isHot: true,
    isNew: false,
    views: 2589000,
    tags: ['太空', '探险', '亲情', 'IMAX'],
  },
  {
    id: '2',
    title: '肖申克的救赎',
    titleEn: 'The Shawshank Redemption',
    year: 1994,
    rating: 9.7,
    category: '悬疑片',
    categorySlug: 'mystery',
    description: '银行家安迪因被误判杀害妻子及其情人而被关进肖申克监狱，在狱中他凭借才智和毅力，不仅赢得了囚犯们的尊重，还通过二十年如一日的坚持，最终实现了自我救赎与自由。这不仅是一部关于希望的影片，更是对人性最深刻的刻画。',
    director: '弗兰克·德拉邦特',
    cast: ['蒂姆·罗宾斯', '摩根·弗里曼', '鲍勃·冈顿', '威廉·赛德勒'],
    duration: '142分钟',
    region: '美国',
    posterUrl: 'https://readdy.ai/api/search-image?query=Shawshank%20Redemption%20movie%20poster%20style%2C%20man%20standing%20in%20rain%20with%20arms%20outstretched%2C%20dark%20prison%20silhouette%20in%20background%2C%20dramatic%20lightning%2C%20cinematic%20film%20poster%20design%2C%20warm%20golden%20light%20breaking%20through%20storm%20clouds%2C%20hope%20and%20freedom%20theme&width=800&height=1200&seq=movie-shawshank-poster&orientation=portrait',
    isHot: true,
    isNew: false,
    views: 3120000,
    tags: ['经典', '希望', '人性', '越狱'],
  },
  {
    id: '3',
    title: '功夫',
    titleEn: 'Kung Fu Hustle',
    year: 2004,
    rating: 8.9,
    category: '动作片',
    categorySlug: 'action',
    description: '周星驰执导并主演的经典功夫喜剧。故事发生在1940年代的上海，小混混阿星误闯猪笼城寨，引发了一场惊天动地的武林大战。融合了无厘头喜剧与中国传统功夫元素，是华语电影史上不可多得的佳作。',
    director: '周星驰',
    cast: ['周星驰', '元华', '元秋', '黄圣依'],
    duration: '99分钟',
    region: '中国香港',
    posterUrl: 'https://readdy.ai/api/search-image?query=Kung%20Fu%20Hustle%20Chinese%20movie%20poster%20style%2C%20martial%20arts%20action%20pose%2C%20vivid%20red%20and%20gold%20color%20scheme%2C%20Chinese%20traditional%20elements%2C%20retro%20Shanghai%20vibe%2C%20comedy%20and%20action%20fusion%2C%20cinematic%20film%20poster%20design%2C%20dramatic%20lighting&width=800&height=1200&seq=movie-kungfu-poster&orientation=portrait',
    isHot: false,
    isNew: true,
    views: 1850000,
    tags: ['功夫', '喜剧', '周星驰', '经典'],
  },
  {
    id: '4',
    title: '你的名字',
    titleEn: 'Your Name',
    year: 2016,
    rating: 8.6,
    category: '动画片',
    categorySlug: 'animation',
    description: '在千年一遇的彗星造访后，生活在乡下小镇的女高中生三叶和东京的男高中生泷，竟然互换了身体。两人在彼此的生活中留下印记，却发现自己与对方之间有着超越时空的联系。新海诚用精美绝伦的画面讲述了一个跨越时空的纯爱故事。',
    director: '新海诚',
    cast: ['神木隆之介', '上白石萌音', '长泽雅美', '市原悦子'],
    duration: '106分钟',
    region: '日本',
    posterUrl: 'https://readdy.ai/api/search-image?query=Your%20Name%20anime%20movie%20poster%20style%2C%20boy%20and%20girl%20looking%20at%20comet%20in%20twilight%20sky%2C%20Japanese%20anime%20aesthetic%2C%20beautiful%20gradient%20sky%20colors%2C%20starry%20night%2C%20romantic%20atmosphere%2C%20soft%20dreamy%20lighting%2C%20clean%20minimalist%20composition&width=800&height=1200&seq=movie-yourname-poster&orientation=portrait',
    isHot: true,
    isNew: false,
    views: 2100000,
    tags: ['动画', '爱情', '奇幻', '新海诚'],
  },
  {
    id: '5',
    title: '寄生虫',
    titleEn: 'Parasite',
    year: 2019,
    rating: 9.0,
    category: '悬疑片',
    categorySlug: 'mystery',
    description: '基泽一家全是无业游民，直到长子通过伪造文凭成为富豪家的家教，一家人如同寄生虫般逐步渗透进上流社会家庭。然而，一桩意想不到的事件打破了表面平静的生活。奉俊昊以黑色幽默揭示韩国社会的贫富差距与阶层矛盾，斩获奥斯卡最佳影片。',
    director: '奉俊昊',
    cast: ['宋康昊', '李善均', '赵汝贞', '崔宇植'],
    duration: '132分钟',
    region: '韩国',
    posterUrl: 'https://readdy.ai/api/search-image?query=Parasite%20Korean%20movie%20poster%20style%2C%20family%20portrait%20with%20dark%20hidden%20meaning%2C%20stark%20contrast%20between%20rich%20and%20poor%2C%20Korean%20cinema%20aesthetic%2C%20geometric%20composition%2C%20black%20and%20white%20with%20subtle%20color%20accents%2C%20minimalist%20design&width=800&height=1200&seq=movie-parasite-poster&orientation=portrait',
    isHot: true,
    isNew: false,
    views: 2890000,
    tags: ['韩国', '社会', '悬疑', '奥斯卡'],
  },
  {
    id: '6',
    title: '盗梦空间',
    titleEn: 'Inception',
    year: 2010,
    rating: 9.3,
    category: '科幻片',
    categorySlug: 'scifi',
    description: '道姆·柯布是一名专门在人们梦境中盗取秘密的窃贼。为了回到孩子身边，他接受了一项看似不可能的任务：在目标人物的潜意识中植入一个想法。层层嵌套的梦境、令人目眩的视觉效果，诺兰再次挑战了观众的想象力极限。',
    director: '克里斯托弗·诺兰',
    cast: ['莱昂纳多·迪卡普里奥', '约瑟夫·戈登-莱维特', '艾伦·佩吉', '汤姆·哈迪'],
    duration: '148分钟',
    region: '美国',
    posterUrl: 'https://readdy.ai/api/search-image?query=Inception%20movie%20poster%20style%2C%20city%20folding%20inward%20dream%20landscape%2C%20man%20standing%20on%20upside%20down%20street%2C%20surreal%20architecture%2C%20dark%20moody%20atmosphere%2C%20cinematic%20lighting%2C%20mind%20bending%20visual%2C%20film%20poster%20design&width=800&height=1200&seq=movie-inception-poster&orientation=portrait',
    isHot: false,
    isNew: false,
    views: 2750000,
    tags: ['科幻', '梦境', '悬疑', '烧脑'],
  },
  {
    id: '7',
    title: '泰坦尼克号',
    titleEn: 'Titanic',
    year: 1997,
    rating: 9.4,
    category: '爱情片',
    categorySlug: 'romance',
    description: '1912年泰坦尼克号邮轮首航，穷画家杰克与贵族少女罗丝在船上相遇相爱。然而巨轮撞上冰山，这段跨越阶级的爱情面临生死考验。詹姆斯·卡梅隆用震撼的视觉和感人至深的故事，创造了影史上最伟大的爱情史诗之一。',
    director: '詹姆斯·卡梅隆',
    cast: ['莱昂纳多·迪卡普里奥', '凯特·温斯莱特', '比利·赞恩', '凯西·贝茨'],
    duration: '194分钟',
    region: '美国',
    posterUrl: 'https://readdy.ai/api/search-image?query=Titanic%20movie%20poster%20style%2C%20couple%20embracing%20on%20ship%20bow%20at%20sunset%2C%20romantic%20ocean%20backdrop%2C%20warm%20golden%20sunset%20lighting%2C%20classic%20Hollywood%20film%20poster%20design%2C%20epic%20romance%20atmosphere%2C%20grand%20ship%20silhouette&width=800&height=1200&seq=movie-titanic-poster&orientation=portrait',
    isHot: false,
    isNew: false,
    views: 3450000,
    tags: ['爱情', '灾难', '经典', '史诗'],
  },
  {
    id: '8',
    title: '千与千寻',
    titleEn: 'Spirited Away',
    year: 2001,
    rating: 9.4,
    category: '动画片',
    categorySlug: 'animation',
    description: '十岁少女千寻随父母搬家途中误入神秘隧道，来到一个满是神灵的奇幻世界。父母因贪吃变成了猪，为了拯救他们，千寻在汤婆婆的汤屋中工作，经历了一段不可思议的成长旅程。宫崎骏的巅峰之作，充满了奇思妙想与东方美学的魅力。',
    director: '宫崎骏',
    cast: ['柊瑠美', '入野自由', '夏木真理', '菅原文太'],
    duration: '125分钟',
    region: '日本',
    posterUrl: 'https://readdy.ai/api/search-image?query=Spirited%20Away%20Studio%20Ghibli%20anime%20movie%20poster%20style%2C%20young%20girl%20in%20Japanese%20bathhouse%20spirit%20world%2C%20colorful%20magical%20creatures%2C%20Japanese%20traditional%20architecture%2C%20hand%20drawn%20animation%20aesthetic%2C%20warm%20glowing%20lanterns%2C%20fantasy%20atmosphere&width=800&height=1200&seq=movie-spiritedaway-poster&orientation=portrait',
    isHot: false,
    isNew: false,
    views: 2680000,
    tags: ['动画', '奇幻', '成长', '宫崎骏'],
  },
  {
    id: '9',
    title: '流浪地球',
    titleEn: 'The Wandering Earth',
    year: 2019,
    rating: 8.3,
    category: '科幻片',
    categorySlug: 'scifi',
    description: '太阳急速老化，人类在地球表面建造了上万座行星发动机，推动地球逃离太阳系，前往4.2光年外的新家园。在这场长达2500年的流浪之旅中，人类面临前所未有的生存危机。中国科幻电影的里程碑之作，视觉震撼，情感真挚。',
    director: '郭帆',
    cast: ['吴京', '屈楚萧', '李光洁', '吴孟达'],
    duration: '125分钟',
    region: '中国大陆',
    posterUrl: 'https://readdy.ai/api/search-image?query=The%20Wandering%20Earth%20Chinese%20sci-fi%20movie%20poster%20style%2C%20giant%20planetary%20engines%20on%20frozen%20earth%20surface%2C%20earth%20moving%20through%20space%2C%20epic%20scale%20sci-fi%2C%20dark%20space%20background%2C%20blue%20engine%20glow%2C%20Chinese%20blockbuster%20aesthetic%2C%20dramatic%20cinematic%20poster&width=800&height=1200&seq=movie-wandering-earth-poster&orientation=portrait',
    isHot: true,
    isNew: false,
    views: 3200000,
    tags: ['科幻', '国产', '灾难', '太空'],
  },
  {
    id: '10',
    title: '喜剧之王',
    titleEn: 'The King of Comedy',
    year: 1999,
    rating: 8.8,
    category: '喜剧片',
    categorySlug: 'comedy',
    description: '跑龙套的尹天仇怀揣演员梦想，在片场屡遭冷遇却始终坚持。他与舞女柳飘飘相遇相知，两个社会底层的小人物在艰难生活中相互取暖，用喜剧的方式演绎了一出感人至深的人生故事。周星驰半自传式的经典之作。',
    director: '周星驰',
    cast: ['周星驰', '张柏芝', '莫文蔚', '吴孟达'],
    duration: '89分钟',
    region: '中国香港',
    posterUrl: 'https://readdy.ai/api/search-image?query=The%20King%20of%20Comedy%20Hong%20Kong%20movie%20poster%20style%2C%20man%20in%20actor%20costume%20looking%20at%20mirror%2C%20stage%20spotlight%2C%20retro%20Hong%20Kong%20cinema%20vibe%2C%20warm%20nostalgic%20lighting%2C%20comedy%20and%20drama%20fusion%2C%20classic%20Chinese%20film%20aesthetic&width=800&height=1200&seq=movie-kingofcomedy-poster&orientation=portrait',
    isHot: false,
    isNew: true,
    views: 1560000,
    tags: ['喜剧', '励志', '周星驰', '经典'],
  },
  {
    id: '11',
    title: '釜山行',
    titleEn: 'Train to Busan',
    year: 2016,
    rating: 8.5,
    category: '恐怖片',
    categorySlug: 'horror',
    description: '一列从首尔开往釜山的高速列车上，突然爆发了丧尸病毒。乘客们在密闭的车厢中奋力求生，人性在极端环境下经受考验。孔刘与马东锡的精彩演绎，将丧尸灾难与人性温暖完美融合，是亚洲丧尸题材电影的巅峰之作。',
    director: '延尚昊',
    cast: ['孔刘', '马东锡', '郑有美', '金秀安'],
    duration: '118分钟',
    region: '韩国',
    posterUrl: 'https://readdy.ai/api/search-image?query=Train%20to%20Busan%20Korean%20zombie%20movie%20poster%20style%2C%20people%20running%20in%20train%20corridor%20from%20zombies%2C%20dramatic%20motion%20blur%2C%20dark%20tense%20atmosphere%2C%20Korean%20horror%20cinema%2C%20emergency%20lighting%2C%20survival%20theme%2C%20intense%20action%20scene&width=800&height=1200&seq=movie-traintobusan-poster&orientation=portrait',
    isHot: false,
    isNew: false,
    views: 1980000,
    tags: ['恐怖', '丧尸', '韩国', '人性'],
  },
  {
    id: '12',
    title: '拯救大兵瑞恩',
    titleEn: 'Saving Private Ryan',
    year: 1998,
    rating: 9.1,
    category: '战争片',
    categorySlug: 'war',
    description: '二战诺曼底登陆后，美国陆军参谋长下令派遣一支小分队深入敌后，寻找并带回阵亡三兄弟中唯一幸存的瑞恩。在残酷的战争环境中，八个人冒着生命危险去拯救一个人。斯皮尔伯格用震撼的战争场面探讨了生命的价值与战争的代价。',
    director: '史蒂文·斯皮尔伯格',
    cast: ['汤姆·汉克斯', '马特·达蒙', '汤姆·塞兹摩尔', '爱德华·伯恩斯'],
    duration: '169分钟',
    region: '美国',
    posterUrl: 'https://readdy.ai/api/search-image?query=Saving%20Private%20Ryan%20movie%20poster%20style%2C%20soldiers%20walking%20through%20war%20zone%20silhouette%2C%20olive%20drab%20and%20dust%20tones%2C%20World%20War%20II%20aesthetic%2C%20cinematic%20war%20film%20poster%2C%20dramatic%20lighting%2C%20heroic%20yet%20somber%20mood%2C%20minimalist%20war%20theme&width=800&height=1200&seq=movie-savingprivate-poster&orientation=portrait',
    isHot: false,
    isNew: false,
    views: 2230000,
    tags: ['战争', '历史', '斯皮尔伯格', '经典'],
  },
  {
    id: '13',
    title: '地球脉动',
    titleEn: 'Planet Earth',
    year: 2006,
    rating: 9.7,
    category: '纪录片',
    categorySlug: 'documentary',
    description: 'BBC历时五年打造的自然纪录片巅峰之作，从南极到北极，从赤道到寒带，从非洲草原到热带雨林，用前所未有镜头展现地球最壮丽的自然景观与最动人的生命故事。每一帧都是壁纸级的画面，带你领略大自然的无穷魅力。',
    director: '艾雷斯泰·法瑟吉尔',
    cast: ['大卫·爱登堡'],
    duration: '550分钟（全11集）',
    region: '英国',
    posterUrl: 'https://readdy.ai/api/search-image?query=Planet%20Earth%20BBC%20documentary%20poster%20style%2C%20aerial%20view%20of%20earth%20from%20space%2C%20lush%20green%20landscapes%2C%20diverse%20wildlife%20montage%2C%20blue%20oceans%2C%20majestic%20mountains%2C%20nature%20documentary%20aesthetic%2C%20breathtaking%20scenery%2C%20minimalist%20elegant%20design&width=800&height=1200&seq=movie-planetearth-poster&orientation=portrait',
    isHot: false,
    isNew: true,
    views: 1450000,
    tags: ['纪录片', '自然', 'BBC', '地球'],
  },
  {
    id: '14',
    title: '花样年华',
    titleEn: 'In the Mood for Love',
    year: 2000,
    rating: 8.8,
    category: '爱情片',
    categorySlug: 'romance',
    description: '1962年的香港，报馆编辑周慕云与邻居苏丽珍发现各自的配偶有了外遇。两人在共同面对背叛的过程中产生了微妙的感情，却始终保持着克制与距离。王家卫用极致的视觉美学，将一段未果的暗恋拍成了华语电影史上最美的爱情诗篇。',
    director: '王家卫',
    cast: ['梁朝伟', '张曼玉', '潘迪华', '萧炳林'],
    duration: '98分钟',
    region: '中国香港',
    posterUrl: 'https://readdy.ai/api/search-image?query=In%20the%20Mood%20for%20Love%20movie%20poster%20style%2C%20man%20and%20woman%20in%20narrow%20alleyway%2C%20Hong%20Kong%201960s%20vintage%20aesthetic%2C%20warm%20muted%20color%20palette%2C%20rain%20slicked%20streets%2C%20romantic%20melancholy%2C%20Wong%20Kar%20Wai%20cinematic%20style%2C%20chinese%20calligraphy%20title&width=800&height=1200&seq=movie-inthemood-poster&orientation=portrait',
    isHot: false,
    isNew: false,
    views: 1320000,
    tags: ['爱情', '王家卫', '文艺', '经典'],
  },
  {
    id: '15',
    title: '速度与激情7',
    titleEn: 'Furious 7',
    year: 2015,
    rating: 8.3,
    category: '动作片',
    categorySlug: 'action',
    description: '多米尼克一家人在战胜了欧文·肖后过着平静的生活，然而欧文的哥哥德卡特·肖前来复仇。从洛杉矶到阿布扎比，从高加索山到东京，一场全球追逐战就此展开。保罗·沃克的最后一部作品，片尾致敬让人泪目。',
    director: '温子仁',
    cast: ['范·迪塞尔', '保罗·沃克', '杰森·斯坦森', '巨石强森'],
    duration: '137分钟',
    region: '美国',
    posterUrl: 'https://readdy.ai/api/search-image?query=Furious%207%20movie%20poster%20style%2C%20sports%20cars%20in%20high%20speed%20chase%20scene%2C%20explosion%20in%20background%2C%20fast%20action%20Hollywood%20blockbuster%20aesthetic%2C%20warm%20desert%20tones%2C%20intense%20motion%2C%20cinematic%20car%20racing%20theme%2C%20dynamic%20composition&width=800&height=1200&seq=movie-furious7-poster&orientation=portrait',
    isHot: false,
    isNew: false,
    views: 3100000,
    tags: ['动作', '赛车', '好莱坞', '保罗·沃克'],
  },
  {
    id: '16',
    title: '让子弹飞',
    titleEn: 'Let the Bullets Fly',
    year: 2010,
    rating: 9.0,
    category: '动作片',
    categorySlug: 'action',
    description: '北洋年间，悍匪张麻子劫了马邦德的火车，冒名顶替上任鹅城县长，与当地恶霸黄四郎展开了一场惊心动魄的斗智斗勇。姜文导演的代表作，黑色幽默与暴力美学的完美结合，每一句台词都堪称经典。',
    director: '姜文',
    cast: ['姜文', '葛优', '周润发', '刘嘉玲'],
    duration: '132分钟',
    region: '中国大陆',
    posterUrl: 'https://readdy.ai/api/search-image?query=Let%20the%20Bullets%20Fly%20Chinese%20movie%20poster%20style%2C%20three%20men%20in%20vintage%20Chinese%20costumes%2C%20wild%20west%20Chinese%20town%2C%20warm%20sepia%20tones%2C%20Chinese%20blockbuster%20aesthetic%2C%20dramatic%20character%20portrait%2C%20bold%20typography%2C%20Jiang%20Wen%20film%20style&width=800&height=1200&seq=movie-letbulletsfly-poster&orientation=portrait',
    isHot: false,
    isNew: false,
    views: 2450000,
    tags: ['动作', '喜剧', '姜文', '国产'],
  },
];

export const hotMovies = movies.filter(m => m.isHot);
export const newMovies = movies.filter(m => m.isNew);

export function getMoviesByCategory(slug: string): Movie[] {
  if (slug === 'all') return movies;
  return movies.filter(m => m.categorySlug === slug);
}

export function getMovieById(id: string): Movie | undefined {
  return movies.find(m => m.id === id);
}